// import logo from './logo.svg';
import MyComponent from './Components/Snake';
import './App.css';

function App() {
  return (
    <div className="App">
      <MyComponent/>
    </div>
  );
}

export default App;
